import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/play/play/src/app/_components/analytics.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MarbleXBackground"] */ "/home/runner/work/play/play/src/app/games/(details)/marblex-games/marblex-background.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MarbleXPageContent"] */ "/home/runner/work/play/play/src/app/games/(details)/marblex-games/marblex-page-content.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Layout"] */ "/home/runner/work/play/play/src/components/layout/Layout.tsx");
